import $ from "jquery"

import "../scss/page.scss";

import "../scss/web-mobile-process.scss";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/slick/market-flow.js";
import "./scripts/matchHeight/market-flow.js";
import "./scripts/ebook.js";


$('.section--standard__wrapper').slick({
  responsive: [
    {
      breakpoint: 5000,
      settings: "unslick"
    },
    {
      breakpoint: 767,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots:false,
      }
    }
  ]
});
